export default function IconUserDeactive() {
  return (
    <svg
      viewBox="0 0 387 408"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="user-check 2" clipPath="url(#clip0_278_2)">
        <g id="Group">
          <path
            id="Vector"
            d="M164.585 0C114.028 0 73.043 41.0483 73.043 91.6839C73.043 142.32 114.028 183.367 164.585 183.367C215.141 183.367 256.127 142.32 256.127 91.6839C256.127 41.0483 215.141 0 164.585 0Z"
            fill="#"
          ></path>
          <path
            id="Vector_2"
            d="M173.688 228.16C178.835 220.676 173.886 209.26 164.812 209.258H140.447C65.2104 209.258 4.21875 270.344 4.21875 345.697C4.21875 376.448 29.109 401.377 59.8125 401.377H166.158C175.342 401.377 180.282 389.673 174.951 382.185C159.304 360.212 150.1 333.316 150.1 304.271C150.1 276.015 158.81 249.795 173.688 228.16Z"
            fill="#"
          ></path>
          <g id="Vector_3">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M387.85 304.232C387.85 361.526 341.476 407.972 284.271 407.972C227.066 407.972 180.691 361.526 180.691 304.232C180.691 246.939 227.066 200.492 284.271 200.492C341.476 200.492 387.85 246.939 387.85 304.232ZM343.543 264.813C349.89 270.383 350.529 280.048 344.971 286.405L292.646 346.238C282.904 357.378 265.766 357.89 255.376 347.352L225.993 317.545C220.066 311.533 220.127 301.846 226.131 295.909C232.134 289.973 241.807 290.034 247.734 296.046L265.577 314.147C269.732 318.361 276.588 318.157 280.484 313.7L321.987 266.243C327.546 259.887 337.198 259.246 343.543 264.813Z"
              fill="#"
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M387.85 304.232C387.85 361.526 341.476 407.972 284.271 407.972C227.066 407.972 180.691 361.526 180.691 304.232C180.691 246.939 227.066 200.492 284.271 200.492C341.476 200.492 387.85 246.939 387.85 304.232ZM343.543 264.813C349.89 270.383 350.529 280.048 344.971 286.405L292.646 346.238C282.904 357.378 265.766 357.89 255.376 347.352L225.993 317.545C220.066 311.533 220.127 301.846 226.131 295.909C232.134 289.973 241.807 290.034 247.734 296.046L265.577 314.147C269.732 318.361 276.588 318.157 280.484 313.7L321.987 266.243C327.546 259.887 337.198 259.246 343.543 264.813Z"
              fill="#"
              fillOpacity="0.2"
            ></path>
          </g>
        </g>
        <ellipse
          id="Ellipse 1"
          cx="284.842"
          cy="306"
          rx="101.842"
          ry="102"
          fill="#"
        ></ellipse>
        <g id="close 1" clipPath="url(#clip1_278_2)">
          <g id="Group_2">
            <g id="close_1_">
              <path
                id="Vector_4"
                d="M229.892 373.147C226.558 373.341 223.279 372.232 220.746 370.055C215.751 365.031 215.751 356.916 220.746 351.892L330.114 242.523C335.309 237.662 343.461 237.932 348.322 243.127C352.718 247.825 352.974 255.045 348.922 260.043L238.909 370.055C236.409 372.201 233.183 373.307 229.892 373.147Z"
                fill="var(--greenLight-color)"
              ></path>
              <path
                id="Vector_5"
                d="M339.132 373.366C335.753 373.352 332.514 372.01 330.115 369.63L220.746 260.261C216.119 254.858 216.748 246.725 222.151 242.098C226.974 237.967 234.087 237.967 238.91 242.098L348.922 351.466C354.116 356.329 354.384 364.481 349.522 369.674C349.329 369.881 349.129 370.081 348.922 370.274C346.228 372.617 342.683 373.736 339.132 373.366Z"
                fill="var(--greenLight-color)"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_278_2">
          <rect width="387" height="408" fill="#"></rect>
        </clipPath>
        <clipPath id="clip1_278_2">
          <rect
            width="136"
            height="136"
            fill="#"
            transform="translate(217 238)"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
}
